import { AnimatePresence, motion } from "framer-motion";
import { RefreshCw, WifiOff } from "lucide-react";
import { cn } from "../lib/utils";

interface ConnectionStatusProps {
	isConnected: boolean;
	isOnline: boolean;
	onRetry?: () => void;
}

export function ConnectionStatusBar({ isConnected, isOnline, onRetry }: ConnectionStatusProps) {
	const show = !isConnected || !isOnline;

	return (
		<AnimatePresence>
			{show && (
				<motion.div
					initial={{ opacity: 0, y: -40 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -40 }}
					className={cn(
						"shrink-0 flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium",
						!isOnline
							? "bg-destructive/10 text-destructive border-b border-destructive/20"
							: "bg-yellow-500/10 text-yellow-500 border-b border-yellow-500/20"
					)}
				>
					<WifiOff className="w-3.5 h-3.5" />
					<span>
						{!isOnline
							? "You're offline. Check your connection."
							: "Connection lost. Reconnecting..."}
					</span>
					{onRetry && (
						<button
							type="button"
							onClick={onRetry}
							className="inline-flex items-center gap-1 ml-1 px-2 py-0.5 rounded bg-background/50 hover:bg-background transition-colors"
						>
							<RefreshCw className="w-3 h-3" />
							Retry
						</button>
					)}
				</motion.div>
			)}
		</AnimatePresence>
	);
}
